import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


import { styled } from '../styles/index.js';
import { ARTWORK_SIZES } from './constants.js';
export var StyledRoot = styled('li', function (_ref) {
  var $theme = _ref.$theme;
  return {
    alignItems: 'center',
    backgroundColor: $theme.colors.backgroundAlt,
    display: 'flex',
    listStyleType: 'none',
    width: '100%'
  };
});
StyledRoot.displayName = "StyledRoot";
export var StyledContent = styled('div', function (_ref2) {
  var $mLeft = _ref2.$mLeft,
      $sublist = _ref2.$sublist,
      $theme = _ref2.$theme;
  return _objectSpread2({}, $theme.borders.border100, {
    alignItems: 'center',
    borderTop: 'none',
    borderRight: 'none',
    borderLeft: 'none',
    display: 'flex',
    flexGrow: 1,
    height: $sublist ? '48px' : '72px',
    justifyContent: 'space-between',
    paddingRight: $theme.sizing.scale500,
    marginLeft: $mLeft ? $theme.sizing.scale500 : null
  });
});
StyledContent.displayName = "StyledContent";
export var StyledEndEnhancerContainer = styled('div', {
  alignItems: 'center',
  display: 'flex'
});
StyledEndEnhancerContainer.displayName = "StyledEndEnhancerContainer";
export var StyledArtworkContainer = styled('div', function (_ref3) {
  var $artworkSize = _ref3.$artworkSize,
      $theme = _ref3.$theme;
  var padding = null;

  switch ($artworkSize) {
    case ARTWORK_SIZES.SMALL:
      padding = $theme.sizing.scale800;
      break;

    case ARTWORK_SIZES.LARGE:
      padding = $theme.sizing.scale600;
      break;

    case ARTWORK_SIZES.MEDIUM:
    default:
      padding = $theme.sizing.scale700;
  }

  return {
    alignItems: 'center',
    display: 'flex',
    paddingLeft: padding,
    paddingRight: padding
  };
});
StyledArtworkContainer.displayName = "StyledArtworkContainer";